import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/did";
import {
  fetchAvailablityDidFailure,
  fetchAvailablityDidSuccess,
} from "../slices/features/availablity";
import { RequestTypes } from "../types";

const appService = new AppService();

function* availabilityDidSaga(action: any) {
  const { payload } = action;
  const { did } = payload;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appService.availabilityDid,
      baseUrl,
      did
    );

    payload?.cbSuccess && payload?.cbSuccess({ ...response });

    yield put(fetchAvailablityDidSuccess({ ...response }));
  } catch (errors: any) {
    const { statusCode, statusText } = errors;
    const message = errors?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchAvailablityDidFailure({ statusCode, statusText }));
  }
}

export function* watchavailabilityDid() {
  yield takeLatest(RequestTypes.AVAILABILITY_DID_REQUEST, availabilityDidSaga);
}
